import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./adicionais-e-descontos-listar/adicionais-e-descontos-listar.module').then(m => m.AdicionaisEDescontosListarModule) },
    { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./adicionais-e-descontos-inserir/adicionais-e-descontos-inserir.module').then(m => m.AdicionaisEDescontosInserirModule) },
    { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./adicionais-e-descontos-editar/adicionais-e-descontos-editar.module').then(m => m.AdicionaisEDescontosEditarModule) },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./adicionais-e-descontos-detalhar/adicionais-e-descontos-detalhar.module').then(m => m.AdicionaisEDescontosDetalharModule) },



  ])],
  exports: [RouterModule]
})
export class AdicionaisEDescontosRoutingModule { }
